/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: ProductsbyCategoryAddComponent
 * Purpose		: This component retrieves specified record and shows details.
 * Dependency	: ProductsbyCategoryService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { Component, OnInit, HostBinding, EventEmitter, Input, Output,
         trigger, transition, animate,
         style, state } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/switchMap';
import { ToastsManager }  from 'ng2-toastr';
import { ProductsbyCategoryData, ProductsbyCategoryService }  from './ProductsbyCategory.service';


@Component({
  template: require('./ProductsbyCategoryDetails.component.html'),
  providers: [ProductsbyCategoryService
	
	],
  animations: [
    trigger('routeAnimation', [
      state('*',
        style({
          opacity: 1,
          transform: 'translateX(0)'
        })
      ),
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateX(-100%)'
        }),
        animate('0.2s ease-in')
      ]),
      transition(':leave', [
        animate('0.5s ease-out', style({
          opacity: 0,
          transform: 'translateY(100%)'
        }))
      ])
    ])
  ]
})

export class ProductsbyCategoryDetailsComponent implements OnInit {
	@HostBinding('@routeAnimation') get routeAnimation() {
		return true;
	}

	@HostBinding('style.display') get display() {
		return 'block';
	}

	// @HostBinding('style.position') get position() {
	//  return 'absolute';
	// }

	objProductsbyCategory: ProductsbyCategoryData;
	errorMessage: string;
	messages: string[];

	// Lookup Arrays
	

	constructor(private route: ActivatedRoute, 
		private router: Router,
		private toastr: ToastsManager,
		private ProductsbyCategoryService: ProductsbyCategoryService

	) {
		// this.id = parseInt(params.get('id'));
		this.objProductsbyCategory = new ProductsbyCategoryData();
	}

	ngOnInit() {
		this.route.params
		// (+) converts string 'id' to a number
		// .switchMap((params: Params) => this.ProductsbyCategoryService.getByID(+params['id']))
		.switchMap((params: Params) => this.ProductsbyCategoryService.getByID(params['id']))
		.subscribe((item: ProductsbyCategoryData) => this.objProductsbyCategory = item);
		this.getLookups();
	}

	deleteProductsbyCategory(id: string) {
		if (window.confirm('Are you sure you want to delete this ProductsbyCategory?') == true) 
		{
			this.ProductsbyCategoryService.deleteProductsbyCategory(this.objProductsbyCategory.CategoryName.toString())
			.subscribe(record => this.router.navigate(['/ProductsbyCategory']),
				error =>  this.errorMessage = 'There was an error while deleting record. Error: ' + <any>error,
				() => { console.log('ProductsbyCategory record deleted successfully...'); }
			);
		}
	}
	gotoProductsbyCategoryEdit() {
		this.router.navigate(['/ProductsbyCategory', this.objProductsbyCategory.CategoryName]);
	}

	gotoProductsbyCategory() {
		this.router.navigate(['/ProductsbyCategory']);
	}


	getLookups() {

	}

	log(msg: string) {
		this.messages.splice(0, 0, msg);
		console.log(msg);
	}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/ProductsbyCategory/ProductsbyCategoryDetails.component.ts